import { useNavigate } from 'react-router-dom'

import { CurrenyFwPolicyPeriodDocument } from 'generated/resources/graphql'
import moment from 'moment'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useLazyQuery } from 'modules/core/hooks/useQuery'

export const useBannerNavigation = ({
  link,
  skipFetch,
}: {
  link?: string | (() => string)
  skipFetch?: boolean
}) => {
  const { company } = useCurrentSession()
  const { navigation } = useNavigation()
  const navigateHook = useNavigate()
  const currentDate = moment().format('YYYY-MM-DD')

  const [fetchCurrentPayrollPeriod, { data: payrollPeriodData }] = useLazyQuery(
    CurrenyFwPolicyPeriodDocument,
    {
      variables: {
        companyId: company.id,
        currentDate,
      },
    }
  )

  useEffect(() => {
    if (!link && !skipFetch) {
      fetchCurrentPayrollPeriod()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const navigate = () => {
    if (link) {
      const getLink = typeof link === 'function' ? link() : link

      navigateHook(getLink)
    } else {
      const currentPolicyPeriod = payrollPeriodData?.payroll.policyPeriodsConnection.nodes[0]

      if (currentPolicyPeriod) {
        const policyId = currentPolicyPeriod.policy?.id
        const periodId = currentPolicyPeriod.id

        navigateHook(
          navigation.payrollBundle.policy.period.cycles.results.fullPath({
            policyId: String(policyId),
            periodId: String(periodId),
          })
        )
      } else {
        navigateHook(navigation.payrollBundle.fullPath())
      }
    }
  }

  return {
    navigate,
  }
}
